import { Lightning, Lightning as lng } from '@lightningjs/sdk';
import { _constants } from './MiniEpgChannelSelector';
import { Theme } from '../../../config/theme';
import { fullUrlWithRecipe, Recipes } from '../../../Business/utility/ImageRecipeUtil';

export class MiniEpgChannelCard extends lng.Component {
  static _template() {
    return {
      w: w => w,
      h: _constants.channelCardHeight,
      Background: {
        w: w => w,
        h: h => h,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 20,
        },
        colorLeft: Theme.Colors.Black,
        colorRight: Theme.Colors.CmsZappingBar.CardSecondary,
      },
      ChannelNumber: {
        x: _constants.leftPadding,
        y: _constants.verticalPaddingFavorite,
        mountX: 0.5,
        text: {
          text: 'Channel Number',
          textAlign: 'center',
        },
      },
      ChannelImage: {
        mountX: 1,
        x: w => w - _constants.rightPadding,
        y: _constants.verticalPadding,
        h: h => h - _constants.verticalPadding * 2,
        w: _constants.maxImageWidth,
        Contain: {
          x: w => w / 2,
          y: h => h / 2,
          mount: 0.5,
          texture: {
            type: lng.textures.ImageTexture,
            src: '',
            resizeMode: {
              type: 'contain',
              w: _constants.maxImageWidth,
              h: _constants.channelCardHeight - _constants.verticalPadding * 2,
            },
          },
        },
      },
      ChannelTitle: {
        mountX: 1,
        mountY: 0.5,
        x: w => w - _constants.rightPadding,
        y: h => h / 2,
        // h: h => h - _constants.verticalPadding * 2,
        w: _constants.maxTextWidth,
        visible: false,
        font: Theme.Fonts.Detail.Title,
        fontSize: 12,
        text: {
          text: 'Channel Title',
          maxLines: 2,
          textAlign: 'center',
          verticalAlign: 'middle',
        },
      },
    };
  }
  _init() {
    this.tag('ChannelNumber').text.text = this.channelModel.channelNumber;

    if (this.channelModel.image.squareLogo) {
      const imageUrl = fullUrlWithRecipe(this.backend, this.channelModel.image.squareLogo, Recipes.MediumChannelLogo); // logo options defaultLogo, posterLogo, squareLogo
      // console.log(imageUrl);
      this.tag('Contain').texture.src = imageUrl;
    } else {
      this.tag('ChannelTitle').text.text = this.channelModel.text.title;
      this.tag('ChannelTitle').visible = true;
    }
  }

  _focus() {
    this.tag('Background').setSmooth('colorRight', Theme.Colors.CmsZappingBar.CardPrimary);
    this.tag('ChannelNumber').patch({
      text: {
        textColor: Theme.Colors.Primary,
      },
    });
  }

  _unfocus() {
    this.tag('Background').setSmooth('colorRight', Theme.Colors.CmsZappingBar.CardSecondary);
    this.tag('ChannelNumber').patch({
      text: {
        textColor: Theme.Colors.White,
      },
    });
  }

  get channelID() {
    return this.channelModel.channelId;
  }

  set focused(val) {
    if (val) {
      this._focus();
    } else {
      this._unfocus();
    }
  }
}
